/**
     * @desc browse页NFT作品列表
用于查询browse页面数据，参考model说明
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/browseItemList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/browseItemList', params);
}
